import "react-multi-carousel/lib/styles.css";
import './css/App.css';

function ArticleCard({pub, title, subtitle, url}){
    return (
        <div className="article-card">
            <hr className="hr-break"></hr>
            <h2>{title}</h2>
            <h4><a href={url} target="_blank">{pub}</a></h4>
            <h3>{subtitle}</h3>
            
        </div>
    )
}

export default ArticleCard;
